<div
  class="flex flex-col justify-start items-stretch gap-y-4 p-4 app-full-height basis-full flex-grow"
>
  <app-controls-form></app-controls-form>
  <div class="w-full overflow-x-auto">
    <app-item-profitability-table></app-item-profitability-table>
  </div>
</div>
